'use client';

import { fetcher } from '@insta-club/api';
import { DashboardProgramSkeleton } from '@insta-club/components/skeleton';
import { Calendar, CalendarResponse } from '@insta-club/models';
import { isSameJalaaliDate } from '@insta-club/utilities';
import { useEffect, useState } from 'react';
import useSWR from 'swr';
import ProgramCalendarHead from './program-calendar-head';
import ProgramDetails from './program-details';

interface Props {
    programID: number;
}

const ProgramCard: React.FC<Props> = ({ programID }) => {
    const [selected, setSelected] = useState<Calendar>();
    const { data, isLoading } = useSWR<CalendarResponse>(`/programs/calendar/${programID}`, (url: string) =>
        fetcher(url, 'dashboard')
    );
    const calendar = data?.calendar;

    useEffect(() => {
        if (!calendar?.length) return;
        const initialDay = calendar.find((d) => isSameJalaaliDate(d.date)) ?? calendar[0];
        setSelected(initialDay);
    }, [calendar]);

    if (isLoading) return <DashboardProgramSkeleton />;

    return (
        <div className='shadow-card relative flex flex-col gap-4 rounded-2xl border border-gray-200 bg-white px-6 py-3'>
            {calendar ? <ProgramCalendarHead value={selected} onChange={setSelected} calendar={calendar} /> : null}
            {selected ? <ProgramDetails id={programID} calendar={selected} /> : null}
        </div>
    );
};

export default ProgramCard;

